
export enum InvoiceRequirementCategoryCd {
	POST_RATING = 'PostRating',
	PRE_RATING = 'PreRating'}

